import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

import Utils from 'utils/Utils.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';
import {fetchSeasonCategories} from 'actions/timeline.js';
import DatabaseService from 'services/DatabaseService.js';
import Competition from './Competition.js';
import {getName, formatLeaderboardValue} from 'modules/leaderboards/tools.js';


class CompetitionContainer extends Component {
    constructor(props){
        super(props);
        this.state = {busy:false};
        this.onLaunchLeaderboard = this.onLaunchLeaderboard.bind(this);
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.loadData();
    }

    loadData() {
        if (this.props.card && this.props.card.season) {
            this.setState({busy:true});
            Promise.all([
                DatabaseService.getSeason(this.props.card.season.id),
                this.props.dispatch(fetchSeasonCategories(this.props.card.season.id))
            ])
            .then(([seasonResult, categoryResult]) => {
                    var season = seasonResult.season;
                    var column = Utils.deref(season, 'leaderboard.column') || 'points';
                    var targetPoints = this.getTargetPoints(season, column);
                    var categories = categoryResult.categories;
                    var challenges = this.getChallenges(categories);
                    this.setState({busy:false, season, categories, targetPoints, column, challenges});
                })
                .catch((error)=> {
                    window.alert('An error occurred - see logs');
                    console.error('ERROR:');
                    console.error(error);
                })
        }
    }

    getChallenges(categories) {
        var result = [];
        for(var i = 0; i < categories.length; i++) {
            result = result.concat(categories[i].challenges);
        }
        return result;
    }

    getTargetPoints(season, column) {
        var result = 1;

        if(season) {
            let records = []
           
            if(season.leaderboard && season.leaderboard.userRecords) {
                records = records.concat(season.leaderboard.userRecords);
            }
            if(season.userRecord) {
                records.push(season.userRecord);
            }

            for(var i = 0; i < records.length; i++) {
                let record = records[i];
                result = Math.max(result, record[column]);
            }

        }

        return result;
    }

    onLaunchLeaderboard(id) {
        this.props.history.push('/leaderboards/'+id);
    }

    render() {
        var userRecords = Utils.deref(this.state, 'season.leaderboard.userRecords');
        var showLeaderboards = !!Utils.deref(this.state, 'season.leaderboard');
        return <Competition card={this.props.card} 
                            season={this.state.season}
                            categories={this.state.categories}
                            challenges={this.state.challenges}
                            userProfile={this.props.userProfile}
                            targetPoints={this.state.targetPoints}
                            column={this.state.column}
                            showLeaderboards={showLeaderboards}
                            getName={getName}
                            formatLeaderboardValue={formatLeaderboardValue}
                            showCompetitionActivities={this.props.showCompetitionActivities}
                            onShowCompetitionActivities={this.props.onShowCompetitionActivities}
                            onLaunchChallenge={this.props.onLaunchChallenge}
                            onLaunchLeaderboard={this.onLaunchLeaderboard}
                            getCompetitionProgressBars={this.props.getCompetitionProgressBars}/>;
    }

}


const mapStateToProps = (state, ownProps) => {
    return {  userProfile: getUserProfileWithDefaults(state.user) };
}

export default withRouter(connect(mapStateToProps)(translate('challenges')(CompetitionContainer)));



// WEBPACK FOOTER //
// ./src/modules/challenges/CompetitionContainer.js